const SpinnerIcon = ({ className = '' }) => (
  <svg className="inline mr-2 w-4 h-4 text-white animate-spin fill-black" aria-hidden="true" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 51A50 50 0 1 1 0 51a50 50 0 0 1 100 0ZM9 51a41 41 0 1 0 82 0 41 41 0 0 0-82 0Z" fill="currentColor"></path><path d="M94 39c2-1 4-3 3-5A50 50 0 0 0 42 1c-3 1-4 3-4 6 1 2 4 3 6 3a41 41 0 0 1 44 26c1 2 4 4 6 3Z" fill="currentFill"></path></svg>
);

export default SpinnerIcon;
